import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ContentCard from '../components/ContentCard';
import SearchBar from '../components/SearchBar';
import { formatCounts } from '../utils/labels';
import './LocationsList.css';

function LocationsList() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const response = await fetch('/api/locations');
      const data = await response.json();
      setLocations(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching locations:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="locations-page"><p>Loading storage locations...</p></div>;
  }

  return (
    <div className="locations-page">
      <div className="page-header">
        <h1>Storage Locations</h1>
        <Link to="/locations/new" className="btn btn-primary">+ Add</Link>
      </div>

      <SearchBar placeholder="Search every storage location, compartment and item" />

      {locations.length === 0 ? (
        <div className="no-items">
          <p>No storage locations found. Create one to get started!</p>
          <Link to="/locations/new" className="btn btn-primary">Create First Storage Location</Link>
        </div>
      ) : (
        <div className="card-list">
          {locations.map(location => (
            <ContentCard
              key={location.id}
              to={`/locations/${location.id}`}
              image={location.image}
              imageMimeType={location.imageMimeType}
              placeholder="🏠"
              title={location.name}
              subtitle={location.description}
              meta={formatCounts(location)}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default LocationsList;
